import DeleteFileDialog from "./DeleteFileDialog";
import PackageDialog from "../PackageDialog";
import CreatePatientDialog from "./CreatePatientDialog";
import DeletePatientDialog from "./DeletePatientDialog";
import MoveFileToPatientDialog from "./MoveFileToPatientDialog";
import RenameFileDialog from "./RenameFileDialog";
import RenamePatientDialog from "./RenamePatientDialog";

const ModalHost = () => {
    return (
        <>
            <PackageDialog />
            <CreatePatientDialog />
            <RenamePatientDialog />
            <RenameFileDialog />
            <DeleteFileDialog />
            <DeletePatientDialog />
            <MoveFileToPatientDialog />
        </>
    );
};

export default ModalHost;
